import { Product } from "../../Models/Product/Product";
import { ProductCategory } from "../../Models/Product/ProductCategory";
import { ShopContent } from "../../Models/WebsiteContent/ShopContent";
import { ObjectDataset } from "@tblabs/storage";
import { ContentProvider } from "./ContentProvider";


export class ShopContentProvider extends ContentProvider<ShopContent>
{
    public get Shop(): ShopContent
    {
        return this.Content;
    }

    constructor(_repo: ObjectDataset<ShopContent>)
    {
        super(_repo);
    }

    public CategoryByUrl(url: string): ProductCategory
    {
        const category = this.Shop.ProductCategories.Items.find(x => x.Url.value == url);

        if (!category)
            return ProductCategory.NotFound();

        return category;
    }

    public ProductsByCategory(category: ProductCategory): Product[]
    {
        return this.Shop.Products.Items.filter(x => x.CategoryId.value == category?.Id.value);
    }

    public GetLowestPriceForProductFromCategory(category: ProductCategory): string
    {
        const allProductsFromCategory = this.ProductsByCategory(category);

        let productWithLowestPrice: Product | undefined;

        allProductsFromCategory.forEach(product =>
        {
            if ((!productWithLowestPrice) || (product.GetPrice() < productWithLowestPrice.GetPrice()))
            {
                productWithLowestPrice = product;
            }
        });

        if (!productWithLowestPrice)
        {
            return "brak produktów";
        }

        return productWithLowestPrice.GetPriceAsText();
    }

    public ProductByUrl(productUrl: string): Product
    {
        const product = this.Shop.Products.Items.find(x => x.Url.value == productUrl);

        if (!product)
            throw new Error(`Product not found`);

        return product;
    }

    public get ProductCategoriesAsTitleIdObject(): object
    {
        return this.Shop.ProductCategories.Items.reduce((prev, curr: ProductCategory) => ({ ...prev, [curr.Title.value]: curr.Id.value }), {});
    }
}
